export default {
    get(key) {
        try {
            const jsonParse = (string) => {
                try {
                    return JSON.parse(string);
                } catch (error) {
                    return string;
                }
            };
            if (document.cookie) {
                if (typeof document.cookie.split("; ").find(row => row.startsWith(key)) !== "undefined") {
                    const cookie = document.cookie.split("; ").find(row => row.startsWith(key)).split(/=/);
                    if (cookie && cookie[1]) {
                        return jsonParse(decodeURIComponent(cookie[1]));
                    }
                }
            }
        } catch (error) {
            console.error(error);
        }
        return null;
    },
    set(key, value) {
        try {
            if (document.cookie) {
                const date = new Date();
                date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
                const expires = date.toUTCString();
                let encoded = encodeURIComponent(value);
                if (typeof value === 'object') {
                    encoded = encodeURIComponent(JSON.stringify(value));
                }
                document.cookie = `${key}=${encoded}; expires=${expires}; path=/`;
            }
        } catch (error) {
            console.error(error);
        }
    },
    remove(key) {
        try {
            if (document.cookie) {
                const date = new Date();
                date.setTime(date.getTime() - 24 * 60 * 60 * 1000);
                const expires = date.toUTCString();
                document.cookie = `${key}=; expires=${expires}; path=/`;
            }
        } catch (error) {
            console.error(error);
        }
    },
}